import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CATEGORIES } from "../lib/perms";

export default function CategoryCourseFields({ a, patch, prefix }) {
  return (
    <>
      <div className="space-y-1.5">
        <Label className="text-xs text-slate-600">Program Category</Label>
        <Select value={a.program_category || ""} onValueChange={v => patch({ program_category: v })}>
          <SelectTrigger data-testid={`${prefix}-category`}><SelectValue placeholder="Select category" /></SelectTrigger>
          <SelectContent>{CATEGORIES.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        {!a.program_category && <div data-testid={`${prefix}-category-review`} className="text-[11px] text-amber-700">Program category needs review{a.category_original_program ? ` · was "${a.category_original_program}"` : ""}</div>}
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs text-slate-600">Course Name</Label>
        <Input data-testid={`${prefix}-course`} key={a.course_name || a.program || ""} defaultValue={a.course_name || a.program || ""} placeholder="e.g. Master of Data Analytics"
          onBlur={e => e.target.value !== (a.course_name || a.program || "") && patch({ course_name: e.target.value })} />
      </div>
    </>
  );
}
